import { ACTION_TYPES } from "./actionTypes"

export const setSoldNFTs = payload => {
  return {
    type: ACTION_TYPES.SET_SOLD_NFTS,
    payload
  }
}
